import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

const Menubar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const getCurrentTab = () => {
    switch (location.pathname) {
      case "/":
        return "home";
      case "/about":
        return "about";
      case "/skills":
        return "skills";
      case "/experience":
        return "experience";
      case "/projects":
        return "projects";
      case "/contact":
        return "contact";
      default:
        return "home";
    }
  };

  const handleSelect = (key) => {
    switch (key) {
      case "home":
        navigate("/");
        break;
      case "about":
        navigate("/about");
        break;
      case "experience":
        navigate("/experience");
        break;
      case "skills":
        navigate("/skills");
        break;
      case "projects":
        navigate("/projects");
        break;
      case "contact":
        navigate("/contact");
        break;
      default:
        navigate("/");
    }
  };

  return (
    <Tabs
      activeKey={getCurrentTab()}
      onSelect={handleSelect}
      className="mb-3"
      style={{ cursor: "pointer" }}
    >
      <Tab eventKey="home" title="Home.jsx"></Tab>
      <Tab eventKey="about" title="AboutMe.jsx"></Tab>
      <Tab eventKey="experience" title="Experience.jsx"></Tab>
      <Tab eventKey="projects" title="Projects.jsx"></Tab>
      <Tab eventKey="skills" title="Skills.jsx"></Tab>
      <Tab eventKey="contact" title="ContactMe.jsx"></Tab>
    </Tabs>
  );
};

export default Menubar;
